import React, { useEffect } from 'react';
import useStore from 'state/store/hooks/useStore';
import ListStores from './listStores';
import accessLocalStorage, { ls } from 'services/localStorage';
import { useNavigate } from 'react-router-dom';

const Stores = () => {
  const { toFetchStoresList, store } = useStore();
  const { storesList } = store;
  const navigate = useNavigate();

  useEffect(() => {
    if (Array.isArray(storesList)) {
      const redirectOrgId = accessLocalStorage.getRedirectOrgId();
      if (redirectOrgId) {
        // to remember org id when redirected from mso
        navigate(`/${redirectOrgId}`);
        accessLocalStorage.clearItem(ls.REDIRECT_ORG_ID);
      }
    }
  }, [storesList]);

  useEffect(() => {
    if (!Array.isArray(storesList)) toFetchStoresList();
  }, []);

  if (store.isLoading > 0) return <></>;

  return <ListStores storesList={storesList} />;
};

export default Stores;
